import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from 'vue-cookies';
import { TUIComponents, TUIChatKit } from "./TUIKit";
import { TUITranslateService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import TUINotification from "./TUIKit/components/TUINotification/index";
import Tinymce from '@/components/tinymce/index.vue'
import http from '@/api/http.js'
import * as $echarts from "echarts";
import moment from 'moment';
import Print from 'vue-print-nb'
import cafeOfd from 'cafe-ofd'
import 'cafe-ofd/package/index.css'
import "@/util/tianditu.js"
import PollService from './utils/pollService'
import './util/eventBus.js'
Vue.prototype.$poll = PollService
Vue.use(cafeOfd)
Vue.prototype.$http = http
Vue.prototype.$echarts = $echarts
Vue.prototype.$moment = moment
Vue.component('tinymce', Tinymce);
Vue.use(VueCookies);
Vue.use(Print)
import "@/plugin/element"
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/icon.css"
import '@/styles/index.scss'
import '@/icons'
import "normalize.css"
import { locales } from "./locales";

const SDKAppID = 1600006482; // Your SDKAppID
const secretKey = "c76d9c62db2fe17501bee330b96c2de9149a6bd223bb9a980a14563313308584"; // Your secretKey

TUIChatKit.components(TUIComponents, Vue);
TUIChatKit.init();

TUITranslateService.provideLanguages(locales);
TUITranslateService.useI18n();

Vue.config.productionTip = false;

//在出现报错的el-radio-group组件上绑定自定义指令
Vue.use(
  Vue.directive('removeAriaHidden', {
    bind(el, binding) {
      //获取节点
      let ariaEls = el.querySelectorAll('.el-radio__original');
      ariaEls.forEach(item => {
        item.removeAttribute('aria-hidden')
      });
    }
  })
)


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

/**
 * Init TUINotification configuration.
 */
TUINotification.setNotificationConfiguration({
  showPreviews: true,
  allowNotifications: true,
  notificationTitle: "Tencent Cloud Chat",
  notificationIcon: "https://web.sdk.qcloud.com/im/demo/latest/faviconnew.png",
});

/**
 * Listen for new messages and use notification components.
 * This capability is only available in the web environmen.
 */
TUIStore.watch(StoreName.CHAT, {
  newMessageList: (newMessageList: unknown) => {
    if (Array.isArray(newMessageList)) {
      newMessageList.forEach(message => TUINotification.notify(message));
    }
  }
});

export { SDKAppID, secretKey };
